import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  rowMenu: {
    position: "absolute",
    top: 0,
    right: 23,
    bottom: 0,
    padding: "0 4px",
    overflow: "hidden",
    zIndex: 1
  },
  menuButtons: {
    display: "flex",
    alignItems: "center",
    padding: 4,
    height: "100%",
    backgroundColor: "#fff",
    boxShadow: "0 0 4px 0 #ccc"
  }
});
